import { render, staticRenderFns } from "./TabInventory.vue?vue&type=template&id=35debf81&"
import script from "./TabInventory.vue?vue&type=script&lang=js&"
export * from "./TabInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports